import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  issuanceCard: {
    '.ant-card-body': {
      padding: 0
    }
  },
  issuanceTable: {
    '.ant-table-tbody > tr > td:first-child': {
      paddingLeft: '24px'
    },
    '.ant-table-thead': {
      display: 'none'
    }
  },
  card: {
    '.ant-card-head': {
      backgroundColor: token.lightGrey.lightGrey1
    },
    '.ant-table-footer': {
      backgroundColor: `${token.primary.primary3}1A`,
      borderTop: 'none'
    }
  },
  medicineCard: {
    border: 'none',
    padding: 0,
    '.ant-card-body': {
      backgroundColor: `${token.primary.primary3}1A`,
      padding: 24
    }
  },
  listItem: {
    padding: '24px !important'
  },

  divider: {
    margin: 0
  },
  collapseTitle: {
    minWidth: 310
  },
  commentCardWrapper: {
    '& .ant-card-body': {
      padding: 0
    }
  },
  commentCard: {
    padding: '16px 24px'
  },
  commentDivider: {
    margin: 0
  },
  commentBeneficiary: {
    padding: '16px 10px',
    borderRadius: 6,
    backgroundColor: token.colorFillSecondary
  }
}))
